import { RouterProvider } from 'react-router-dom'
import { router } from './router'

function App() {
  return (
    <>
      <div className="grain-overlay" />
      <RouterProvider router={router} />
    </>
  )
}

export default App
